/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { LineSegments } from 'three';
let ShapeLine = class ShapeLine extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const inf = 1000000; // indefinite line
        const x12 = shape.x1 + shape.xDir * inf;
        const y12 = shape.y1 + shape.yDir * inf;
        const x22 = shape.x1 - shape.xDir * inf;
        const y22 = shape.y1 - shape.yDir * inf;
        const geometry = Solids.createLineSegment(x12, y12, 0, x22, y22, 0);
        if (decoration != null && decoration.LineWidth > 0) {
            this.add(new LineSegments(geometry, CrownShape.getLineMaterial(decoration)));
        }
    }
    format() {
        return undefined;
    }
};
ShapeLine = tslib_1.__decorate([
    Shape('Shape.Line'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], ShapeLine);
export { ShapeLine };
//# sourceMappingURL=ShapeLine.js.map